import { CodeListItemWire } from '../../common';
import { CodeListItem } from '../types-store';
import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

export const mapListToStore = (codeItems: CodeListItemWire[]): CodeListItem[] => {

  return codeItems && codeItems
    .map(item => ({
      ...(item.code && { id: item.code.v }),
      ...(isDefinedIncludingZero(item.factor) && { factor: item.factor }),
      ...(item.comments && { comments: item.comments }),
      ...(item.validFrom && { validFrom: parseAsDateUTC(item.validFrom) }),

      ...(!!item.indicatorSubstance && {
        indicatorSubstance: {
          value: item.indicatorSubstance.v,
          description: item.indicatorSubstance.d
        }
      }),

      ...(!!item.indicatorSubstanceCategory && {
        indicatorSubstanceCategory: {
          value: item.indicatorSubstanceCategory.v,
          description: item.indicatorSubstanceCategory.d
        }
      }),
      ...(!!item.indicatorSubstanceUom && {
        indicatorSubstanceUom: {
          value: item.indicatorSubstanceUom.v,
          description: item.indicatorSubstanceUom.d
        }
      }),
      ...(!!item.indicatorType && {
        indicatorType: {
          value: item.indicatorType.v,
          description: item.indicatorType.d
        }
      }),
      ...(!!item.substance && {
        substance: {
          value: item.substance.v,
          description: item.substance.d
        }
      }),
      ...(!!item.substanceCategory && {
        substanceCategory: {
          value: item.substanceCategory.v,
          description: item.substanceCategory.d
        }
      }),
      ...(!!item.substanceUom && {
        substanceUom: {
          value: item.substanceUom.v,
          description: item.substanceUom.d
        }
      }),
      ...(!!item.location && {
        location: {
          value: item.location.v,
          description: item.location.d
        }
      }),
      ...(!!item.unit && {
        unit: {
          value: item.unit.v,
          description: item.unit.d
        }
      }),
      ...(!!item.source && {
        source: {
          value: item.source.v,
          description: item.source.d
        }
      }),
      ...(!!item.equipment && {
        equipment: {
          value: item.equipment.v,
          description: item.equipment.d
        }
      })
    })) || [] as CodeListItem[];
};
